import SelectMultipleInput from './SelectMultipleInput';

export default SelectMultipleInput;
